// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"26693278","225":"2fccd700","242":"48f40122","339":"4e23fa1d","346":"0bd28013","469":"4e933bd8","514":"9c6ef570","567":"f47bbfa2","613":"f556d0af","670":"57db01e5"}[chunkId] + ".chunk.js";
};